var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{ref:"editor",staticClass:"form-control",class:{ disabled: _vm.disabled },attrs:{"value":_vm.fromValue(_vm.value),"options":{
    mode: _vm.language,
    lineNumbers: true,
    autoRefresh: true,
    readOnly: _vm.disabled,
    // lineWrapping: true,
  },"state":_vm.error ? 'invalid' : null},on:{"input":function($event){_vm.$emit('input', _vm.fromValue(arguments[0]))}}})}
var staticRenderFns = []

export { render, staticRenderFns }